/**
 * Created by JIA on 2020/6/29.
 *  Parse and display the text contains our marks
 *      e.g.: This will be \h{highlight} , and a input \i{1|defaultValue}, a full line input \i{f}
 *      \h -> highlight text ,in {} is the content
 *      \i -> input, in {1|defaultValue} the "1" is the default length, the "defaultValue" is the defaultValue of input, if the length is a "f" it will fill rest of current line
 *      \u -> underline text, in {} is the content
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Icon } from "antd";
import MessageBox from "./MessageBox";
import * as FAIcons from "@fortawesome/free-solid-svg-icons";

import Constants from "../../config/Constants";
import "../../assets/scss/screens/admin/unit/fields/types/MarkTextEditor.scss";
import { convertToPinyin, convertToFileServerPath } from "../../utils/Helper";
import { EnumHasFlag, GetDefaultAnswerToShow, ParseSentence, ParseSetting, IsAnswerRightForInput } from "../../utils/MarkTextHelper";
import UIDs from "../../UIDs";

// /**
//  * Parse the text into Arrays of object
//  *  object will be like
//  *      {
//  *          type: "plaintext"/"highlight"/"input",
//  *          setting:{
//  *              initialCharCount: "f", // for input
//  *              ...
//  *          },
//  *          text: ""
//  *      }
//  *
//  *      Then we will render it by type
//  * @param str
//  * @constructor
//  */
//
// const ParseMarkTextStrPart = str => {
//     const parseRegExp = /\\([hiu])\{([^}]*)\}/gm;
//
//     if (parseRegExp.test(str)) {
//         parseRegExp.lastIndex = 0; //reset last index since we use g flag
//
//         let matches = parseRegExp.exec(str);
//         if (matches && matches.length === 3) {
//             const type = matches[1];
//
//             switch (type) {
//                 case "h":
//                     return {
//                         type: Constants.TEXT_MARK_TYPE.HIGHLIGHT,
//                         setting: {},
//                         text: matches[2],
//                     };
//                 case "i":
//                     const innerPart = matches[2];
//                     const paramArray = innerPart.split("|");
//                     let initialCharCount = 4;
//                     let defaultValue = "";
//                     if (paramArray.length === 1) {
//                         initialCharCount = paramArray[0];
//                     } else if (paramArray.length === 2) {
//                         initialCharCount = paramArray[0];
//                         defaultValue = paramArray[1];
//                     }
//
//                     return {
//                         type: Constants.TEXT_MARK_TYPE.INPUT,
//                         setting: {
//                             initialCharCount: initialCharCount,
//                             defaultValue: defaultValue,
//                         },
//                         text: "",
//                     };
//                 case "u":
//                     return {
//                         type: Constants.TEXT_MARK_TYPE.UNDERLINE,
//                         setting: {},
//                         text: matches[2],
//                     };
//                 default:
//                     return {
//                         type: Constants.TEXT_MARK_TYPE.PLAIN_TEXT,
//                         setting: {},
//                         text: str,
//                     };
//             }
//         }
//     }
//
//     return {
//         type: Constants.TEXT_MARK_TYPE.PLAIN_TEXT,
//         setting: {},
//         text: str,
//     };
// };
//
// /**
//  * we do not consider nest for now
//  *      use array as a stack to parse strings
//  * @param text
//  * @returns {[]}
//  * @constructor
//  */
// const ParseMarkText = text => {
//     let arr = [];
//     const validTypeChar = ["i", "h", "u"];
//
//     if (text && text.length > 0) {
//         let helperArr = [];
//         let markStarArr = [];
//         let markEndArr = [];
//
//         let isMatching = false;
//         let matchingType = -1; //0 mark start, 1 inner, 2 mark end
//
//         for (let i = 0; i < text.length; i++) {
//             let char = text[i];
//
//             //start match and pop previous as a plain text
//             //if is something like \i{ , we got the start
//             if (char === "\\" && text.length > i + 1 && validTypeChar.indexOf(text[i + 1]) > -1 && text[i + 2] === "{") {
//                 if (!isMatching) {
//                     if (i !== 0) {
//                         arr.push(ParseMarkTextStrPart(helperArr.join("")));
//                     }
//                     helperArr = [];
//                     isMatching = true;
//                     matchingType = 0;
//                 } else {
//                     //nothing to do if already in matching?> this may be nest, we ignore for now
//                 }
//             }
//             helperArr.push(char);
//
//             if (isMatching) {
//                 //met the end part
//                 if (char === "}" && matchingType === 1) {
//                     matchingType = 2;
//                 }
//
//                 switch (matchingType) {
//                     case 0:
//                         markStarArr.push(char);
//                         break;
//                     case 1:
//                     default:
//                         break;
//                     case 2:
//                         markEndArr.push(char);
//                         break;
//                 }
//
//                 //start go to inner part
//                 if (char === "{" && matchingType === 0) {
//                     matchingType = 1;
//                 }
//
//                 //try end match
//                 if (char === "}") {
//                     const startStr = markStarArr.join("");
//                     const endStr = markEndArr.join("");
//                     if (matchingType === 2) {
//                         if (endStr === "}" && /\\([hiu])\{/gm.test(startStr)) {
//                             //end case
//                             isMatching = false;
//                             matchingType = -1;
//                             markStarArr = [];
//                             markEndArr = [];
//                             arr.push(ParseMarkTextStrPart(helperArr.join("")));
//                             helperArr = [];
//                         } else {
//                             //reset to case 1
//                             matchingType = 1;
//                             markEndArr = [];
//                         }
//                     }
//                 }
//             }
//         }
//
//         if (helperArr.length > 0) {
//             arr.push(ParseMarkTextStrPart(helperArr.join("")));
//         }
//     }
//     return arr;
// };

/**
 * if do not has input in this sentence we can use text as container
 * @param array
 * @returns {boolean}
 * @constructor
 */
const HasInputInText = array => {
    return _.filter(array, item => EnumHasFlag(item.type, (Constants.TEXT_MARK_TYPE.INPUT | Constants.TEXT_MARK_TYPE.POP_INPUT))).length > 0;
};

const HasWriteInputInText = array => {
    return _.filter(array, item => EnumHasFlag(item.type, Constants.TEXT_MARK_TYPE.WRITE_INPUT)).length > 0;
};

const buildValueArray = (parsedArr, showDefaultValue, initInputValueArray) => {
    let inputIndexArray = [];
    let returnArr = [];
    let inputIndex = -1;
    for (let i = 0; i < parsedArr.length; i++) {
        let item = parsedArr[i];

        if (EnumHasFlag(item.type, Constants.TEXT_MARK_TYPE.INPUT) || EnumHasFlag(item.type, Constants.TEXT_MARK_TYPE.POP_INPUT) || EnumHasFlag(item.type, Constants.TEXT_MARK_TYPE.WRITE_INPUT)) {
            inputIndex += 1;
            let inputDefaultText = "";
            if (showDefaultValue) {
                inputDefaultText = item.setting.defaultValue;
            } else {
                if (initInputValueArray && _.isArray(initInputValueArray) && initInputValueArray.length > inputIndex) {
                    inputDefaultText = initInputValueArray[inputIndex];
                }
            }
            returnArr.push(inputDefaultText);
            inputIndexArray.push(i);
        } else {
            returnArr.push(item.text);
        }
    }

    return {
        valueArray: returnArr,
        inputIndexArray: inputIndexArray,
    };
};

const isNumeric = num => (typeof num === "number" || (typeof num === "string" && num.trim() !== "")) && !isNaN(num);

const PencilIcon = props => {
    return (
        <i
            style={props.style}
            dangerouslySetInnerHTML={{
                __html:
                    '<svg class="" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="689"><path d="M1004.8 193.6c-54.4-56-110.4-115.2-164.8-169.6C827.2 11.2 809.6 3.2 793.6 3.2s-30.4 3.2-43.2 16L105.6 657.6c-1.6 1.6-3.2 3.2-3.2 6.4l-96 297.6-1.6 4.8c-4.8 12.8-1.6 27.2 6.4 38.4 12.8 14.4 33.6 19.2 52.8 12.8l296-96c1.6 0 4.8-1.6 6.4-3.2l638.4-638.4c12.8-12.8 17.6-25.6 17.6-43.2s-8-35.2-17.6-43.2z m-688 649.6L108.8 912 176 704l459.2-449.6 136 136-454.4 452.8z m513.6-513.6l-136-136 92.8-92.8c46.4 46.4 92.8 92.8 136 140.8l-92.8 88z" p-id="690"></path></svg>',
            }}
        />
    );
};

const uid = UIDs.components.ui.marktextrender;
class MarkTextRender extends Component {
    constructor(props) {
        super(props);
        const sentenceCommandObj = ParseSentence(this.props.content);
        const parsedArr = sentenceCommandObj.words; //ParseMarkText(sentenceCommandObj.content);
        const { valueArray, inputIndexArray } = buildValueArray(parsedArr, props.showDefaultInputValue, props.initialInputValue);

        this.state = {
            sentenceMark: sentenceCommandObj.type,
            sentenceSetting: sentenceCommandObj.setting,
            parsedArr: parsedArr,
            valueArr: valueArray,
            inputIndexArray: inputIndexArray,
            hasInput: HasInputInText(parsedArr),
            hasWriteInput: HasWriteInputInText(parsedArr),
            popupImage: null,
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.content !== this.props.content) {
            const sentenceCommandObj = ParseSentence(nextProps.content);
            const parsedArr = sentenceCommandObj.words; //ParseMarkText(sentenceCommandObj.content);
            const { valueArray, inputIndexArray } = buildValueArray(parsedArr, nextProps.showDefaultInputValue, nextProps.initialInputValue);
            if (
                !_.isEqual(this.state.parsedArr, parsedArr) ||
                !_.isEqual(this.state.valueArr, valueArray) ||
                !_.isEqual(this.state.inputIndexArray, inputIndexArray) ||
                !_.isEqual(sentenceCommandObj.type, this.state.sentenceMark) ||
                !_.isEqual(sentenceCommandObj.setting, this.state.sentenceSetting)
            ) {
                this.setState({
                    sentenceMark: sentenceCommandObj.type,
                    sentenceSetting: sentenceCommandObj.setting,
                    parsedArr: parsedArr,
                    valueArr: valueArray,
                    inputIndexArray: inputIndexArray,
                    hasInput: HasInputInText(parsedArr),
                    hasWriteInput: HasWriteInputInText(parsedArr),
                });
            }
        }
    }

    componentDidMount() {
        if (this.props.onMounted) {
            setTimeout(() => {
                this.props.onMounted();
            }, 0);
        }
    }

    render() {
		if (_.isNumber(this.state.sentenceMark)) {
			if (EnumHasFlag(this.state.sentenceMark, Constants.SENTENCE_MARK_TYPE.DIALOG)) {
				const parsedSetting = ParseSetting(this.state.sentenceSetting);
				if (parsedSetting && parsedSetting.role) {
					if (_.toLower(parsedSetting.role) === "a") {
						return this.renderDialog("a");
					} else if (_.toLower(parsedSetting.role) === "b") {
						return this.renderDialog("b");
					}
				}
			}
		}

		return this.renderContent();
    }

    renderContent = () => {
        const { multiline, pinyinMode, placeholderTextColor, t, showRightOrWrongColor, showTips, showTipsBelow, inputStyle, tipTextStyle } = this.props;
        const sentenceStyle = this.getSentenceStyle(this.state.sentenceMark, this.state.sentenceSetting, this.state.hasInput);
        //some style need use a class, for now its indent
		const className = sentenceStyle.sentenceClassName;
        //we split every char as a text and use flex wrap to make sure the input can be inline

        return (
            <div style={{ ...(this.state.hasInput ? styles.container : null), ...sentenceStyle, ...this.props.containerStyle }} className={className}>
                {this.state.popupImage ? this.renderPopupImage() : null}
                {this.state.parsedArr.map((item, i) => {
                    let text = pinyinMode ? convertToPinyin(item.text) : item.text;
                    text = text.replace(/ /g, "\u00a0"); // force space be &nbsp; to have a width
                    switch (item.type) {
                        case Constants.TEXT_MARK_TYPE.PLAIN_TEXT:
                        case Constants.TEXT_MARK_TYPE.HIGHLIGHT:
                        case Constants.TEXT_MARK_TYPE.UNDERLINE:
                        case Constants.TEXT_MARK_TYPE.POP_INPUT:
                        case Constants.TEXT_MARK_TYPE.BOLD:
                        case Constants.TEXT_MARK_TYPE.ICON:
                        case Constants.TEXT_MARK_TYPE.SKIP:
                        case Constants.TEXT_MARK_TYPE.KEYWORD:
                        default:
                            if (this.props.overriddenWord && this.props.overriddenWord.renderOverriddenWord) {
                                if (EnumHasFlag(this.props.overriddenWord.type, item.type)) {
                                    return this.props.overriddenWord.renderOverriddenWord(item, i); // give the i as key for array
                                }
                            }

                            let style = {
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-all',
                            };
                            if (EnumHasFlag(item.type, Constants.TEXT_MARK_TYPE.BOLD)) {
                                style = { ...style, ...styles.bold };
                            }
                            if (EnumHasFlag(item.type, Constants.TEXT_MARK_TYPE.HIGHLIGHT)) {
                                style = { ...style, ...styles.highlight };
                            }
                            if (EnumHasFlag(item.type, Constants.TEXT_MARK_TYPE.UNDERLINE)) {
                                style = { ...style, ...styles.underline };
                            }
                            if (EnumHasFlag(item.type, Constants.TEXT_MARK_TYPE.SKIP)) {
                                style = { ...style, ...styles.skip };
                            }
                            if (EnumHasFlag(item.type, Constants.TEXT_MARK_TYPE.KEYWORD)) {
                                style = { ...style, ...styles.keyword };
                            }

                            const isPopInput = EnumHasFlag(item.type, Constants.TEXT_MARK_TYPE.POP_INPUT);
                            if (isPopInput) {
                                const defaultValue = this._getDefaultValueForInputToShow(i);
                                text = pinyinMode ? convertToPinyin(defaultValue) : defaultValue;
                                const showPlaceHolder = !text || text.length === 0;
                                let placeHolderStyle = {};
                                if (showPlaceHolder) {
                                    text = this._getPlaceholderForInput(i);
                                    if (!text || text.length === 0) {
                                        text = t("defaultPlaceHolder");
                                    }
                                    placeHolderStyle = { color: placeholderTextColor };
                                }

                                const mergeStyle = { ...style, ...placeHolderStyle, ...this.props.extraTextStyle };

                                return multiline ? (
                                    _.map(text, (char, subIndex) => (
                                        <span key={`${i}-${subIndex}`} style={mergeStyle}>
                                            {char}
                                        </span>
                                    )).concat([
                                        <span key={"whiteSpace"} style={mergeStyle}>
                                            {" "}
                                        </span>,
                                        <PencilIcon key={"pencilIcon"} style={mergeStyle} />,
                                    ])
                                ) : (
                                    <span key={i} style={mergeStyle}>
                                        {text} {<PencilIcon style={mergeStyle} />}
                                    </span>
                                );
                            } else if (EnumHasFlag(item.type, Constants.TEXT_MARK_TYPE.ICON)) {
                                let { name, size, color } = item.setting;

                                if (_.isUndefined(name) || _.isEmpty(name)) {
                                    MessageBox.danger(t("emptyIconName", { name: name }));
                                }
                                if (_.isUndefined(FAIcons[name])) {
                                    MessageBox.danger(t("invalidIcon", { name: name }));
                                    name = "faQuestion";
                                }
                                return <FontAwesomeIcon icon={FAIcons[name]} style={{ width: size, height: size, ...style, ...this.props.extraTextStyle }} color={color} />;
                            } else {
                                return multiline ? (
                                    _.map(text, (char, subIndex) => (
                                        <span key={`${i}-${subIndex}`} style={{ ...style, ...this.props.extraTextStyle }}>
                                            {char}
                                        </span>
                                    ))
                                ) : (
                                    <span key={i} style={{ ...style, ...this.props.extraTextStyle }}>
                                        {text}
                                    </span>
                                );
                            }

                        case Constants.TEXT_MARK_TYPE.INPUT:
                            const fullLine = item.setting && item.setting.initialCharCount && item.setting.initialCharCount === "f";
                            let defaultValue = this._getDefaultValueForInputToShow(i);
                            defaultValue = pinyinMode ? convertToPinyin(defaultValue) : defaultValue;
                            const showPlaceHolder = !defaultValue || defaultValue.length === 0;
                            let placeHolderStyle = {};
                            let finalContent = defaultValue;
                            if (showPlaceHolder) {
                                finalContent = this._getPlaceholderForInput(i);
                                placeHolderStyle = { color: placeholderTextColor };
                            }
                            if (fullLine) {
                                return (
                                    <span className={"zf-input-full-fake"} key={i} style={placeHolderStyle}>
                                        {finalContent}
                                    </span>
                                );
                            } else {
                                const initCount = item.setting && item.setting.initialCharCount && isNumeric(item.setting.initialCharCount) ? item.setting.initialCharCount : 4;
                                let trueVal = item.setting.defaultValue;
                                let isRight = IsAnswerRightForInput(defaultValue, trueVal);
                                return (
                                    <div style={styles.tipStyle}  key={i} >
                                        <div
                                            className={"zf-input-fake"}
                                            style={{
                                                minWidth: `${initCount}em`,
                                                ...inputStyle,
                                                color: (showRightOrWrongColor && trueVal) ? (showTips ? "green" : (isRight ? "green" : "red")) : inputStyle.color,
                                                ...(i === 0 ? {marginLeft: -3} : {}),
                                                ...placeHolderStyle,
                                            }}
                                        >
                                            {showTips ? GetDefaultAnswerToShow(trueVal) : (finalContent || <>&nbsp;</>)}
                                        </div>
                                        {showTipsBelow && !isRight &&
                                            <div
                                                style={{
                                                    ...(i === 0 ? {marginLeft: -9} : {}),
                                                    ...tipTextStyle
                                                }}
                                            >
                                                {GetDefaultAnswerToShow(trueVal)}
                                            </div>
                                        }
                                    </div>
                                );
                            }

                        case Constants.TEXT_MARK_TYPE.WRITE_INPUT:
                            let currentWriteValue = this._getDefaultValueForInputToShow(i);
                            let currentWriteImages = [];
                            // @files@~/fs/temp/tables/123.png|~/fs/temp/tables/456.png
                            if (currentWriteValue.startsWith('@files@')) {
                                currentWriteImages = currentWriteValue.substring(7).split('|');
                            }
                            return (
                                <span key={i}
                                    style={{
                                        marginLeft:"7px",
                                        marginRight:"7px",
                                        paddingLeft:"3px",
                                        paddingRight:"3px",
                                        paddingBottom:"2px",
                                        ...inputStyle,
                                        ...(i === 0 ? {marginLeft: -3} : {}),
                                        cursor: "pointer",
                                        textAlign:"left",
                                        borderBottom:"1px solid #d9d5dc",
                                    }}>
                                    {currentWriteImages.map(this.renderImage)}
                                    {currentWriteImages.length === 0 ?
                                     (<span style={{color: placeholderTextColor}}>{this.props.t('handWrite')}</span>) : null}
                                    {currentWriteImages.length === 0 ?
                                     (<FontAwesomeIcon icon={FAIcons.faPencilAlt} style={{ paddingLeft:5, width: 16, height: 16 }} color={'#333'} />) : null}
                                </span>
                            );
                    }
                })}
            </div>
        );
    }

    renderImage = (url, index) => {
        return (<img key={index} style={{marginTop: 8, marginBottom: 2, marginLeft: (index ? 2 : 0),
                                         width: 36, height: 36, backgroundColor: '#f0fafc'}}
                src={convertToFileServerPath(url)} onClick={() => {
                    this.setState({popupImage: url});
                }}/>);
    }

    renderPopupImage = () => {
        if (!this.state.popupImage) {
            return null;
        }
        return (<div style={{position: 'absolute', width: '80%', top: 30, backgroundColor: '#f0fafc'}} onClick={() => this.setState({popupImage: null})}>
                <div style={{position: 'relative'}}>
                <img style={{width: '100%'}} src={convertToFileServerPath(this.state.popupImage)}/>
                <div style={{position: 'absolute', right: -10, top: -10, width: 30, height: 30,
                             display: 'flex', alignItems: 'center', justifyContent: 'center',
                             borderRadius: 15, borderStyle: 'solid', borderWidth: 4,
                             borderColor: '#666666', cursor: "pointer"}}
                onClick={() => this.setState({popupImage: null})}>
                <Icon type={'close'} style={{ fontSize: 18, fontWeight: 'bold' }} color='#666' />
                </div>
                </div>
                </div>);
    }

    renderDialog = (role) => {
		return (
			<div style={{display: "flex", flexDirection: (role === "a" ? "row" : "row-reverse"), justifyContent: "flex-start", alignItems: "center", margin: "20px 0px"}}>
				<div style={{...(role === "a" ? {marginRight: "10px"} : {marginLeft: "10px"}), flex: 1, alignSelf:"flex-start"}}>
					<div className="avatar avatar-sm rounded-circle" style={{...styles.avatarStyle, ...this.props.extraTextStyle}}>{_.toUpper(role)}</div>
				</div>
				<div style={{flex: 8, display: "flex", justifyContent: (role === "a" ? "flex-start" : "flex-end")}}>
					{this.renderContent()}
				</div>
				<div style={{flex: 1}}></div>
			</div>
		);
	}

    getSentenceStyle = (sentenceCommand, sentenceCommandSetting, hasInput) => {
        let styleObj = hasInput ? styles.container : {};
        let parsedSetting = null;
        if (sentenceCommandSetting) {
            if (_.isString(sentenceCommandSetting) && sentenceCommandSetting !== "") {
                try {
                    parsedSetting = JSON.parse(sentenceCommandSetting);
                } catch (e) {}
            } else if (_.isPlainObject(sentenceCommandSetting)) {
                parsedSetting = sentenceCommandSetting;
            }
        }
        if (EnumHasFlag(sentenceCommand, Constants.SENTENCE_MARK_TYPE.ALIGN_CENTER)) {
            styleObj = { ...styleObj, ...styles.centerAligned };
        } else if (EnumHasFlag(sentenceCommand, Constants.SENTENCE_MARK_TYPE.ALIGN_RIGHT)) {
            styleObj = { ...styleObj, ...styles.rightAligned };
        }

        if (EnumHasFlag(sentenceCommand, Constants.SENTENCE_MARK_TYPE.LEFT_INDENT)) {
            styleObj = { ...styleObj, ...styles.leftIndent };
        }
        if (EnumHasFlag(sentenceCommand, Constants.SENTENCE_MARK_TYPE.DIALOG)) {
            if (parsedSetting && parsedSetting.role) {
                if (_.toLower(parsedSetting.role) === "a") {
                    styleObj = { ...styleObj, ...styles.dialogRoleA };
                } else if (_.toLower(parsedSetting.role) === "b") {
                    styleObj = { ...styleObj, ...styles.dialogRoleB };
                }
            }
        }
        return styleObj;
    };

    _getDefaultValueForInputToShow = index => {
        if (this.state.inputIndexArray.indexOf(index) > -1) {
            const rIndex = this.state.inputIndexArray.indexOf(index);
            // if show the default value from mark string, we show it
            if (this.props.initialInputValue && this.props.initialInputValue.length > rIndex) {
                return this.props.initialInputValue[rIndex];
            } else {
                //other wise we show the default value from unit design
                if (this.props.showDefaultInputValue) {
                    const defaultValue = this.state.parsedArr[index].setting.defaultValue;
                    return GetDefaultAnswerToShow(defaultValue);
                }
            }
        }

        return "";
    };

    _getPlaceholderForInput = index => {
        if (this.state.inputIndexArray.indexOf(index) > -1) {
            const rIndex = this.state.inputIndexArray.indexOf(index);
            // if show the default value from mark string, we show it
            if (this.props.inputPlaceHolder && _.isArray(this.props.inputPlaceHolder) && this.props.inputPlaceHolder.length > rIndex) {
                return this.props.inputPlaceHolder[rIndex];
            } else {
                return this.state.parsedArr[index].setting.placeholder;
            }
        }

        return "";
    };
}
const styles = {
    bold: {
        fontWeight: "bold",
    },
    highlight: {
        color: "#1785af",
    },
    underline: {
        textDecoration: "underline",
    },
    container: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
    },
    centerAligned: {
        textAlign: "center",
        alignSelf: "center",
        justifyContent: "center",
    },
    rightAligned: {
        textAlign: "right",
        alignSelf: "flex-end",
        justifyContent: "flex-end",
    },
    leftIndent: {
        //paddingLeft: "12px",
        textIndent: "2em",
        sentenceClassName: "markPreventSubIndent", // when there is input, we use div display flex, so we must prevent span inside inherit the textIndent
    },
    avatarStyle: {
        backgroundColor: "#f2f2f2",
        color: "#333"
	},
    dialogRole: {
        padding: "12px",
        borderRadius: "5px",
        maxWidth: "240px",
        flexWrap: "wrap",
        overflow:"hidden"
    },
    dialogRoleA: {
        backgroundColor: "#f2f2f2",
    },
    dialogRoleB: {
        backgroundColor: "#ffdfd5",
    },
    skip: {
        color: "transparent",
        width: "0px",
        display:"none",
    },
    keyword: {
        color: "#1785af",
        textDecoration: "underline",
    },
    tipStyle: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    }
};

MarkTextRender.propTypes = {
    containerStyle: PropTypes.object,
    extraTextStyle: PropTypes.object,
    inputStyle: PropTypes.object,
    content: PropTypes.string,
    onContentChange: PropTypes.func,
    multiline: PropTypes.bool,
    pinyinMode: PropTypes.bool,
    showDefaultInputValue: PropTypes.bool, // show the default value parsed from the mark string or not, if it is false, we will try to show value from initialInputValue for the review your input case
    initialInputValue: PropTypes.array,
    inputPlaceHolder: PropTypes.array,
    placeholderTextColor: PropTypes.string,
    overriddenWord: PropTypes.object,
    renderOverriddenWord: PropTypes.func,
    showRightOrWrongColor: PropTypes.bool,
    showTips: PropTypes.bool,
    showTipsBelow: PropTypes.bool,
    tipTextStyle: PropTypes.object,
};
MarkTextRender.defaultProps = {
    containerStyle: {},
    extraTextStyle: {},
    inputStyle: {},
    content: "",
    onContentChange: () => {},
    multiline: false,
    pinyinMode: false,
    showDefaultInputValue: false,
    initialInputValue: [],
    inputPlaceHolder: [],
    placeholderTextColor: "#a5a5a5",
    overriddenWord: { type: 0, renderOverriddenWord: null }, // customize words' display and control
    showRightOrWrongColor: false,
    showTips: false,
    showTipsBelow: false,
    tipTextStyle: {},
};
/**
 * for build init value
 * @param val
 */
const GetInitialValueOfData = val => {
    const parsedArr = ParseSentence(val).words;
    const resultArr = buildValueArray(parsedArr);
    return resultArr.join("");
};
export default withTranslation(uid, { withRef: true })(MarkTextRender);
export { ParseSentence, GetInitialValueOfData };
